import { create } from 'zustand';

/**
 * global state for product price
 * this will be set to the response from the Pricing Service
 * e.g. format
  "product_prices": {
    "4306103": {
      "per_price_inc_vat": "1074.3",
      "per_price": "895.25",
      "per_pack": 1,
      "quantity": 1.0,
      "price": 895.25,
      "price_inclusive": 1074.3,
      "unit": "each",
      "breaks": { "data": [] }
    }
  }
*/
const usePricingStore = create(set => ({
  productPrice: null,
  setPrice: productPrice => set(() => ({ productPrice })),
}));

export default usePricingStore;
